import { WappSession } from '../../common'
import { useSrcURL } from './react-hooks'

export function WappIframe({
  wapp,
  hidden,
}: {
  wapp: WappSession
  hidden?: boolean
}) {
  const { wappSessionId, wappId, elementName, mode, servIndexes } = wapp
  const srcAddress = useSrcURL({ wappId, mode, servIndexes })

  return (
    <iframe
      id={wappSessionId}
      title="wapp"
      style={{
        width: '100%',
        height: '100%',
        border: 'none',
        visibility: hidden ? 'hidden' : 'unset',
      }}
      name={elementName}
      src={srcAddress}
      allow="fullscreen; geolocation; microphone; camera; accelerometer; gyroscope; midi; usb; display-capture; cross-origin-isolated; autoplay; web-share; speaker-selection; encrypted-media; clipboard-read; clipboard-write"
      referrerPolicy="origin"
      allowFullScreen
    />
  )
}

WappIframe.defaultProps = {
  hidden: false,
}
